<template>
<!-- 理事会照片 -->
  <div class="pic-show">
    <div class="title">{{$t('proposalPicShow.title')}}</div>
    <div class="council">
      <div class="pic orange" @click="onClickPic">
        <img src="../../assets/logos/towers.png" />
      </div>
      <div class="pic" @click="onClickPic">
        <img src="../../assets/logos/tower.png" />
      </div>
      <div class="pic" @click="onClickPic">
        <img src="../../assets/logos/hexa.png" />
      </div>
      <div class="pic" @click="onClickPic">
        <img src="../../assets/logos/leaf.png" />
      </div>
    </div>
    <Modal v-model="isNodeDetailModalShow" class="node-detail-modal" :closable="false" :width="766">
      <dna-node-detail-modal @cancelModal="isNodeDetailModalShow = false"></dna-node-detail-modal>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import dnaNodeDetailModal from '@/components/NodeDetailModal/NodeDetailModal.vue'
export default {
  data () {
    return {
      isNodeDetailModalShow: false
    }
  },
  methods: {
    onClickPic () {
      this.isNodeDetailModalShow = true
    }
  },
  components: {
    dnaNodeDetailModal
  }
}
</script>

<style lang="less" scoped>
@import url('./ProposalPicShow.less');
</style>